import { DesignSystem } from '@adornis/chemistry/elements/theming/design.js';
import { themeConfiguration } from '@adornis/digitale-helden-shared/client/theme/configuration.js';

const getMarketingThemeConfiguration = () => {
  const configuration = themeConfiguration;
  configuration.colors.tone['lightGreen'] = '#E7EDBC';
  configuration.colors.tone.darkGrey = '#8F8F8F';

  return configuration;
};

DesignSystem.prefix = 'd';
DesignSystem.setTheme('digitale-helden', {
  ...getMarketingThemeConfiguration(),
});
DesignSystem.useTheme('digitale-helden');
